import { PostComposer } from '@tribeplatform/react-components/PostComposer'
import { PostComposerProps } from '@tribeplatform/react-components/PostComposer/@types'

import { BC } from '../../types/index.js'

export const PostComposerBlock: BC<PostComposerProps> = PostComposer
